import { render, staticRenderFns } from "./ChoiceSubSubject.vue?vue&type=template&id=fbe49f2a&scoped=true&"
import script from "./ChoiceSubSubject.vue?vue&type=script&lang=js&"
export * from "./ChoiceSubSubject.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceSubSubject.vue?vue&type=style&index=0&id=fbe49f2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe49f2a",
  null
  
)

export default component.exports